

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {SplitBillReturnDto, SplitReceiverType} from "@/api/appService";
import api from '@/api'
import moment from 'moment'

@Component({
  name: 'BillDetailReturnDetail',
  filters: {
    formatAmount(value: number) {
      return (value / 100.0).toFixed(2)
    },
    formatType(value: SplitReceiverType) {
      if (value === SplitReceiverType.AllianceBusiness) {
        return '共建机构'
      } else if (value === SplitReceiverType.Platform) {
        return '平台'
      } else {
        return value;
      }
    }
  }
})
export default class BillDetailReturnDetail extends Vue {


  @Prop({required: true})
  billDetailId!: number;

  activeId = ''

  returns: SplitBillReturnDto[] = []

  loading = true;


  formatTitle(splitBillReturn: SplitBillReturnDto) {
    return `${moment(splitBillReturn.creationTime).format('YYYY-MM-DD HH:mm')}  退款：￥${(splitBillReturn.refundAmount! / 100.0).toFixed(2)}`
  }


  mounted() {
    this.fetchData()
  }


  @Watch('billDetailId')
  fetchData() {
    if (this.billDetailId) {
      this.loading = true;
      api.splitBill.getSplitReturns({splitBillDetailId: this.billDetailId}).then(res => {
        this.returns = res ?? []
        this.loading = false
      })
    } else {
      this.returns = []
    }

  }


}

